import { inject, PLATFORM_ID } from "@angular/core";
import { isPlatformServer } from "@angular/common";
import { ResolveFn } from "@angular/router";
import { WPItem } from "src/app/models/wp-item.model";
import { WordPressService } from "src/app/services/word-press.service";

function set404Status(response: any) {
  if (response && typeof response.status === "function") {
    response.status(404);
  }
}

export const newsItemResolver: ResolveFn<WPItem | null> = async (route) => {
  const wordpressService = inject(WordPressService);
  const platformId = inject(PLATFORM_ID);
  const id = route.paramMap.get("id");

  // Inject response on server-side for status code setting
  let serverResponse: any = null;
  if (isPlatformServer(platformId)) {
    try {
      serverResponse = inject("RESPONSE" as any);
    } catch (e) {
      console.warn("Could not inject server response:", e);
    }
  }

  if (!id) {
    set404Status(serverResponse);
    return null;
  }

  try {
    const newsItem = await wordpressService.getPost(id);

    if (!newsItem) {
      set404Status(serverResponse);
      return null;
    }

    return newsItem;
  } catch (error) {
    console.error("Error fetching news item:", error);
    set404Status(serverResponse);
    return null;
  }
};
